module.exports = __webpack_public_path__ + "media/images/pages/ai/photo-3-3dc61b0a7f9fdb887935a20da4644095.png";